import { motion } from "framer-motion";
import { Download, Sparkles, ArrowUpRight } from "lucide-react";

const Hero = ({ onOpenCatalogue }) => {
    return (
        <section data-testid="hero-section" className="relative pt-24 md:pt-28 pb-32 overflow-hidden">

            <div className="sxe-container relative">
                <div className="grid lg:grid-cols-[1.15fr_1fr] gap-10 lg:gap-16 items-center">
                    {/* Left column */}
                    <div>
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="sxe-chip"
                            data-testid="hero-eyebrow"
                        >
                            <Sparkles className="w-3 h-3" />
                            AI-native Enterprise Learning Experience Platform
                        </motion.div>

                        <motion.h1
                            initial={{ opacity: 0, y: 24 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.05 }}
                            className="font-display font-medium text-white mt-6 text-5xl md:text-6xl lg:text-[66px] leading-[1.05] tracking-tighter"
                            data-testid="hero-headline"
                        >
                            <span className="text-gradient-soft">Xelerating</span>
                            <br />
                            <span className="text-gradient-soft">Careers.</span>
                            <br />
                            <span className="text-gradient">Building Futures.</span>
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.15 }}
                            className="mt-6 text-[#B0A3C4] text-lg md:text-xl leading-relaxed max-w-xl"
                            data-testid="hero-subheadline"
                        >
                            SpringXE unifies learning, labs, assessments, and talent orchestration on one AI-native platform — so enterprises can build the workforce their future demands.
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.25 }}
                            className="mt-9 flex flex-col sm:flex-row gap-3"
                        >
                            <button
                                type="button"
                                onClick={onOpenCatalogue}
                                data-testid="hero-cta-catalogue"
                                className="btn-primary"
                            >
                                Download Catalogue <Download className="w-4 h-4" />
                            </button>
                            <a href="#contact" data-testid="hero-cta-experts" className="btn-secondary">
                                Talk to Our Experts <ArrowUpRight className="w-4 h-4" />
                            </a>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className="mt-8 flex flex-wrap items-center gap-5 text-[11px] uppercase tracking-widest text-[#8f7fb0] font-display"
                        >
                            <span className="flex items-center gap-2">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#C266FF] animate-pulse-glow" />
                                SOC 2 Aligned
                            </span>
                            <span>GDPR + DPDP Ready</span>
                            <span>Enterprise SSO</span>
                            <span>500+ Enterprises</span>
                        </motion.div>
                    </div>

                    {/* Right column visual — hero animation, blended into the dark background */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.96 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.9 }}
                        className="relative rounded-3xl overflow-hidden lg:-ml-16 lg:-mr-12 xl:-mr-16 2xl:-mr-48 lg:-mt-10"
                    >
                        <video
                            autoPlay
                            muted
                            loop
                            playsInline
                            preload="auto"
                            aria-label="Global enterprise workforce capability visual"
                            className="w-full aspect-video object-cover"
                        >
                            <source src="/videos/hero/hero-animation.mp4" type="video/mp4" />
                        </video>

                        {/* Fade on all 4 sides so the video blends transparently into the page background */}
                        <div className="absolute inset-x-0 top-0 h-14 bg-gradient-to-b from-[#07020F] to-transparent pointer-events-none" />
                        <div className="absolute inset-x-0 bottom-0 h-14 bg-gradient-to-t from-[#07020F] to-transparent pointer-events-none" />
                        <div className="absolute inset-y-0 left-0 w-14 bg-gradient-to-r from-[#07020F] to-transparent pointer-events-none" />
                        <div className="absolute inset-y-0 right-0 w-14 bg-gradient-to-l from-[#07020F] to-transparent pointer-events-none" />
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
